import { render, staticRenderFns } from "./modifyScorePopup.vue?vue&type=template&id=ef6e4944&scoped=true"
import script from "./modifyScorePopup.vue?vue&type=script&lang=js"
export * from "./modifyScorePopup.vue?vue&type=script&lang=js"
import style0 from "./modifyScorePopup.vue?vue&type=style&index=0&id=ef6e4944&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6e4944",
  null
  
)

export default component.exports